import { render, staticRenderFns } from "./TechnicianCard.vue?vue&type=template&id=6adcdeb2&"
import script from "./TechnicianCard.vue?vue&type=script&lang=ts&"
export * from "./TechnicianCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports